module.exports = "<div class=\"searchbox\">\n  <div class=\"searchbox__container\">\n    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n    <form class=\"searchbox__from\" [formGroup]=\"searchForm\" (ngSubmit)=\"searchLot()\">\n      <input placeholder=\"Search All Equipment\" formControlName=\"keySearch\" />\n    </form>\n    <i class=\"fa fa-times-circle\" aria-hidden=\"true\" (click)=\"searchForm.value.keySearch = ''\"></i>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/searchbox/searchbox.component.html
// module id = ./src/app/components/searchbox/searchbox.component.html
// module chunks = main